import React from 'react';
import { Link } from 'react-router-dom';
import { useStorefrontSettings } from '../context/StorefrontSettingsContext';
import './TopBar.css';

const TopBar = () => {
  const { showProductRequest } = useStorefrontSettings();

  return (
    <div className="top-bar">
      <div className="top-bar-container top-bar-container--links-only">
        <div className="top-bar-right">
          <Link to="/help" className="top-bar-link">Help centre</Link>
          <Link to="/about" className="top-bar-link">About Us</Link>
          <Link to="/blog" className="top-bar-link">Blog</Link>
          {showProductRequest && (
            <Link to="/product-request" className="top-bar-button">
              Request a Product
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
